<div style="padding-left: 3px;" fxLayout="row">
    <div fxFlex="16px">
        <fa-icon matTooltip="Rafraichir" class="fakelink" (click)="reload()" [icon]="['fas','sync-alt']"></fa-icon>
    </div>
    <div fxFlex="grow">&nbsp;</div>
    <div fxFlex="16px">
        <fa-icon matTooltip="Mon agendas" class="fakelink" (click)="openUserAgenda()" [icon]="['fas','calendar']"></fa-icon>
    </div>
</div>
<div style="height: 45px;padding-left: 3px;">
    <div *ngFor="let appointment of appointments" (click)="selectAppointment(appointment)" style="height: 12px;font-size:10px;width:450px;">
        <fa-icon matTooltip="Sélectionner" class="fakelink" [icon]="['fas','user']"></fa-icon>
        <span *ngIf="appointment.domain" style="margin-left: 5px;font-weight: bold;">({{ appointment.group?.properties.Lastname }})</span>
        <span style="margin-left: 5px;border:1px solid gray;border-radius: 3px;padding-left:2px;padding-right:2px;">{{ appointment.properties.Hour }}:{{ appointment.properties.Minute}}</span>
        <span style="margin-left: 5px;">{{ appointment.properties.PatientInfo }}</span>
    </div>
</div>